import type { CompleteOnboardingDto, OnboardingResult } from '@repo/contracts';

import { apiFetch } from '../api/client';

export const completeOnboarding = (form: CompleteOnboardingDto) =>
  apiFetch<OnboardingResult>('/onboarding', {
    body: JSON.stringify(form),
    method: 'POST',
  });

/**
 * Best guess at the visitor's country, to prefill the form — the same lookup
 * flotoapps' onboarding makes. A plain country name or nothing: any failure
 * just leaves the field for the user to pick.
 */
export async function detectCountry(): Promise<string | null> {
  const res = await fetch('https://ipapi.co/country_name/');
  if (!res.ok) return null;
  const name = (await res.text()).trim();
  return name || null;
}

export const onboardingKeys = {
  detectedCountry: ['onboarding', 'detected-country'] as const,
};
